import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useQuery } from '@apollo/client';
import { Divider } from '@mui/material';
import { COMMUNITY_PROFILE_SETTINGS } from 'common/graphql/queries/community/community-profile-settings';
import { useUpdateCommunityMutation } from 'common/hooks/community/useUpdateCommunityMutation';
import CircularProgressMui from 'components/Loading/CircularProgresMui';
import SettingsForm from 'main/pages/SettingsPage/components/SettingsForm/SettingsForm';
import SettingsGroup from 'main/pages/SettingsPage/components/SettingsGroup/SettingsGroup';
import { useTranslation } from 'react-i18next';
import communityProfileGroupsConfig from './communityProfileGroupsConfig';
var CommunityProfile = function (_a) {
    var communityId = _a.communityId;
    var t = useTranslation().t;
    var _b = useQuery(COMMUNITY_PROFILE_SETTINGS, {
        variables: {
            id: communityId
        }
    }), data = _b.data, loading = _b.loading;
    if (loading)
        return _jsx(CircularProgressMui, {}, void 0);
    return (_jsx(SettingsForm, { header: _jsx(_Fragment, { children: t('Профайл сообщества') }, void 0), content: communityProfileGroupsConfig.length > 0 &&
            communityProfileGroupsConfig.map(function (settingsGroup) { return (_jsxs("div", { children: [_jsx(SettingsGroup, { settingsGroup: settingsGroup, data: data === null || data === void 0 ? void 0 : data.community, handleChangeData: useUpdateCommunityMutation }, void 0), _jsx(Divider, { light: true }, void 0)] }, settingsGroup.id)); }) }, void 0));
};
export default CommunityProfile;
